export const POSTAL_CODE_MAX_LENGTH = 10;

const SEPARATOR = /[ -]/;
const SEPARATORS_ALL = /[ -]+/g;

/**
 * Realtime formatter for alphanumeric postal codes, e.g.
 * UK "SW1A 1AA", CA "K1A 0B1", NL "1011 AB", AR "C1000ZAA", IE "D01 H678".
 * Rule: uppercase [A-Z0-9] blocks with at most one separator (space/hyphen) between them.
 * A trailing separator is kept so the user can keep typing the second block.
 */
export const formatPostalCode = (raw: string): string => {
  const cleaned = raw
    .toUpperCase()
    .replace(/[^A-Z0-9 -]/g, "")
    .replace(/^[ -]+/, "");

  const separatorIndex = cleaned.search(SEPARATOR);
  if (separatorIndex < 0) {
    return cleaned.slice(0, POSTAL_CODE_MAX_LENGTH);
  }

  const head = cleaned.slice(0, separatorIndex);
  const separator = cleaned[separatorIndex];
  const tail = cleaned.slice(separatorIndex + 1).replace(SEPARATORS_ALL, "");

  return `${head}${separator}${tail}`.slice(0, POSTAL_CODE_MAX_LENGTH);
};

export const finalizePostalCode = (value: string): string =>
  value.replace(/[ -]+$/, "");
